import React from 'react';

function TitleInsurance({title}) {
  return (<div className={'insurance__box px-0'}>
    <div>
      <span>
         <svg
           xmlns="http://www.w3.org/2000/svg"
           width="10"
           height="12"
           fill="none"
           viewBox="0 0 10 12"
         >
      <path
        fill="#5D70B5"
        d="M1 7.732c-1.333-.77-1.333-2.694 0-3.464L7 .804c1.333-.77 3 .192 3 1.732v6.928c0 1.54-1.667 2.502-3 1.732L1 7.732z"
      ></path>
    </svg>
      </span>
      <span className={'px-2'}>
        {title}
      </span>
    </div>
  </div>);
}

export default TitleInsurance;